<app-page-data-panel
  title="Payslips"
  subtitle="Published payroll outputs available to you."
  [resultText]="payslips.length + ' payslips'">
  <div class="payslip-summary">
    <div><span>Total payslips</span><strong>{{ payslips.length }}</strong></div>
    <div><span>Total net</span><strong>{{ totalNet | currency:'SAR':'symbol':'1.0-2' }}</strong></div>
  </div>

  @if (payslips.length) {
    <p-table [value]="payslips" responsiveLayout="stack" breakpoint="768px">
      <ng-template pTemplate="header">
        <tr>
          <th>Payslip</th>
          <th>Status</th>
          <th>Gross</th>
          <th>Deductions</th>
          <th>Net</th>
          <th>Published</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-payslip>
        <tr>
          <td><span class="p-column-title">Payslip</span>{{ payslip.payslipNumber || ('Payslip #' + payslip.payslipId) }}</td>
          <td><span class="p-column-title">Status</span><p-tag [value]="label(payslip.payslipStatus)" [severity]="statusSeverity(payslip.payslipStatus)"></p-tag></td>
          <td><span class="p-column-title">Gross</span>{{ payslip.grossAmount | currency:(payslip.currencyCode || 'SAR'):'symbol':'1.0-2' }}</td>
          <td><span class="p-column-title">Deductions</span>{{ payslip.deductionAmount | currency:(payslip.currencyCode || 'SAR'):'symbol':'1.0-2' }}</td>
          <td><span class="p-column-title">Net</span>{{ payslip.netAmount | currency:(payslip.currencyCode || 'SAR'):'symbol':'1.0-2' }}</td>
          <td><span class="p-column-title">Published</span>{{ payslip.publishedAt | date:'medium' }}</td>
        </tr>
      </ng-template>
    </p-table>
  } @else {
    <p class="empty-state">No payslips published yet.</p>
  }
</app-page-data-panel>
